import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const Portfolio = () => {
  useEffect(() => {
    // Initialize Isotope when component mounts
    if (window.Isotope && window.imagesLoaded) {
      const isotopeContainer = document.querySelector('.isotope-container');
      if (isotopeContainer) {
        window.imagesLoaded(isotopeContainer, () => {
          const initIsotope = new window.Isotope(isotopeContainer, {
            itemSelector: '.isotope-item',
            layoutMode: 'masonry',
            filter: '*',
            sortBy: 'original-order'
          });

          // Filter functionality
          const filters = document.querySelectorAll('.isotope-filters li');
          filters.forEach(filter => {
            filter.addEventListener('click', function() {
              document.querySelector('.isotope-filters .filter-active')?.classList.remove('filter-active');
              this.classList.add('filter-active');
              initIsotope.arrange({
                filter: this.getAttribute('data-filter')
              });
            });
          });
        });
      }
    }

    // Initialize GLightbox
    if (window.GLightbox) {
      window.GLightbox({
        selector: '.glightbox'
      });
    }
  }, []);

  const portfolioItems = [
    {
      id: 1,
      filter: 'filter-web',
      image: '/images/portfolio-7.webp',
      type: 'Web Platform',
      title: 'Enterprise Resource Planning Portal',
      description: 'Custom ERP portal for inventory, orders, and reporting—built with React and Node.js, deployed on AWS.',
      rating: '4.8',
      tech: ['React', 'Node.js', 'AWS']
    },
    {
      id: 2,
      filter: 'filter-mobile',
      image: '/images/portfolio-8.webp',
      type: 'Mobile App',
      title: 'Field Service Management App',
      description: 'Cross-platform app for scheduling, work orders, and real-time sync—Flutter front-end with REST and push APIs.',
      rating: '4.9',
      tech: ['Flutter', 'Firebase', 'REST API']
    },
    {
      id: 3,
      filter: 'filter-branding',
      image: '/images/portfolio-9.webp',
      type: 'Cloud Migration',
      title: 'Legacy System Cloud Migration',
      description: 'Full migration of on-prem workloads to Azure with refactored architecture and automated DevOps pipelines.',
      rating: '5.0',
      tech: ['Azure', 'Terraform', 'DevOps']
    },
    {
      id: 4,
      filter: 'filter-ui',
      image: '/images/portfolio-10.webp',
      type: 'UI/UX',
      title: 'Healthcare Analytics Dashboard',
      description: 'Real-time analytics dashboard for clinicians—accessible design, role-based access, and secure data handling.',
      rating: '4.7',
      tech: ['Figma', 'React', 'FHIR']
    },
    {
      id: 5,
      filter: 'filter-web',
      image: '/images/portfolio-11.webp',
      type: 'E-commerce',
      title: 'B2B E-commerce Platform',
      description: 'B2B ordering platform with custom pricing, approval workflows, and integration to existing ERP and CRM.',
      rating: '4.6',
      tech: ['React', 'Node.js', 'Stripe']
    },
    {
      id: 6,
      filter: 'filter-mobile',
      image: '/images/portfolio-12.webp',
      type: 'Fintech',
      title: 'Banking & Payments Mobile App',
      description: 'Secure mobile banking app with biometrics, push notifications, and compliance-ready architecture.',
      rating: '4.8',
      tech: ['Swift', 'Kotlin', 'OAuth']
    }
  ];

  return (
    <section id="portfolio" className="portfolio section">
     

      <div className="container" data-aos="fade-up" data-aos-delay="100">
        <div className="isotope-layout" data-default-filter="*" data-layout="masonry" data-sort="original-order">
          <ul className="portfolio-filters isotope-filters" data-aos="fade-up" data-aos-delay="200">
            <li data-filter="*" className="filter-active">All Projects</li>
            <li data-filter=".filter-web">Web Design</li>
            <li data-filter=".filter-mobile">Mobile Apps</li>
            <li data-filter=".filter-branding">Branding</li>
            <li data-filter=".filter-ui">UI/UX</li>
          </ul>

          <div className="row gy-4 isotope-container" data-aos="fade-up" data-aos-delay="300">
            {portfolioItems.map((item) => (
              <div key={item.id} className={`col-xl-4 col-lg-6 portfolio-item isotope-item ${item.filter}`}>
                <div className="portfolio-wrapper">
                  <div className="portfolio-image">
                    <img src={item.image} alt={item.title} className="img-fluid" loading="lazy" />
                    <div className="portfolio-hover">
                      <div className="portfolio-actions">
                        <a href={item.image} className="glightbox action-btn preview-btn" title="Preview Project">
                          <i className="bi bi-eye"></i>
                        </a>
                        <Link to={`/portfolio/${item.id}`} className="action-btn details-btn" title="View Details">
                          <i className="bi bi-arrow-up-right"></i>
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className="portfolio-content">
                    <div className="portfolio-meta">
                      <span className="project-type">{item.type}</span>
                      <div className="project-rating">
                        <i className="bi bi-star-fill"></i>
                        <span>{item.rating}</span>
                      </div>
                    </div>
                    <h3>{item.title}</h3>
                    <p>{item.description}</p>
                    <div className="portfolio-tech">
                      {item.tech.map((tech, idx) => (
                        <span key={idx} className="tech-badge">{tech}</span>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="portfolio-cta text-center" data-aos="fade-up" data-aos-delay="400">
          <h4>Ready to start your next project?</h4>
          <p>Let's work together to bring your digital vision to life</p>
          <div className="cta-buttons">
            <Link to="/contact" className="btn btn-primary">Start a Project</Link>
            <Link to="/portfolio" className="btn btn-outline">View All Work</Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
